import { useCallback, useEffect, useState } from "react";
import {
  Button,
  Confirm,
  useDataProvider,
  useNotify,
  useResourceContext,
  useTranslate,
} from "react-admin";
import { useMutation } from "react-query";
import PrintIcon from "@mui/icons-material/Print";
import ExcelMyIcon from "../myIcons/ExcelMyIcon";

const ExcelButton = ({
  recordId,
  setPrintRecord,
  setResetPrintContent,
  ...props
}) => {
  const resource = useResourceContext();
  const [open, setOpen] = useState(false);
  const notify = useNotify();
  const dataProvider = useDataProvider();
  const t = useTranslate();

  const { data, isLoading, mutate, error } = useMutation((prm) => {
    return dataProvider.getListNoParams(
      resource + prm + "/" + encodeURIComponent(recordId)
    );
  });

  useEffect(() => {
    if (error) {
      notify("mine.notification." + error.message.split(" ").join("_"), {
        type: "error",
      });
    }
  }, [error]);

  useEffect(() => {
    if (data && data.link) {
      setOpen(false);
      const newlink = document.createElement("a");
      newlink.setAttribute("href", data.link);
      newlink.setAttribute("target", "_blank");
      document.body.appendChild(newlink);

      var clickEvent = new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: false,
      });
      newlink.dispatchEvent(clickEvent);
      newlink.remove();
    }
  }, [data]);

  const handleClick = (e) => {
    e.stopPropagation();
    setOpen(true);
  };
  const handleDialogClose = () => setOpen(false);

  const handleConfirm = () => {
    mutate("/excel");
  };

  const save = useCallback((values) => {
    mutate(values);
    setOpen(false);
  }, []);

  return (
    <>
      <Button
        label="Excel"
        disabled={isLoading}
        variant="outlined"
        startIcon={
          <ExcelMyIcon />
        }
        sx={{
          mx: 1,
          "& > .MuiButton-startIcon": {
            // mr: 0,
          },
        }}
        {...props.btnProps}
        onClick={handleClick}
      />
      <Confirm
        isOpen={open}
        loading={isLoading}
        title={t("mine.dialog.print_delivery_note")}
        content="mine.message.export_content"
        onConfirm={handleConfirm}
        onClose={handleDialogClose}
        {...props.dialogProps}
      />
    </>
  );
};

export default ExcelButton;
